export const formatToJST = (utcDateStr: string) => {
    const utcDate = new Date(utcDateStr);
    const jstDate = new Date(utcDate.getTime() + 9 * 60 * 60 * 1000);
    const formattedDate = `${jstDate.getFullYear()}年${jstDate.getMonth() + 1}月${jstDate.getDate()}日${String(jstDate.getHours()).padStart(2, '0')}:${String(jstDate.getMinutes()).padStart(2, '0')}`;
    return formattedDate;
  };